module.exports = {
    templateUrl: 'patterns/components/background-pattern-01.html'
};